import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { Redirect } from 'react-router';
import { ResponsableService } from '../../../services/ResponsableService';
import { AdresseForm } from '../../genericComponents/AdresseForm/AdresseForm';
import { SubscriptionsService } from '../../../services/SubscriptionService';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';

interface Props {
    register?: (form: FormAdhere1) => void;
    hidden: boolean;
    disabled: boolean;
    switch?: (n: number) => void;
    user_id: number;
}

/*interface AdresseResponsable {
    numeroResponsable: string;
    rueResponsable: string;
    complementResponsable: string;
    codePostalResponsable: string;
    villeResponsable: string;
}

interface Responsable {
    nomResponsable: string;
    lienParente: string;
    adresseResponsable: AdresseResponsable;
    telephoneResponsable: string;
}*/

interface State {
    /*nom: string;
    prenom: string;
    date_de_naissance: string;
    adresse: ReqType.Adresse;
    telephone: string;
    responsable: Responsable;
    redirect: boolean;
    taille: string;
    pointure: string;*/
    form: ReqType.SubscriptionPart1;
    redirect: boolean;
}

/**
 * Ce composant permet l'affichage du fomulaire d'adhesion partie1
 */
export class FormAdhere1 extends React.Component {

    props: Props;
    state: State;

    /*private adr: ReqType.Adresse = { id: -1, numero: '', rue: '', complement: '', code_postal: '', ville: ''};
    private adrResp: AdresseResponsable = { numeroResponsable: '', rueResponsable: '',
        complementResponsable: '', codePostalResponsable: '', villeResponsable: ''};
    private resp: Responsable = { nomResponsable: '', lienParente: '', adresseResponsable: this.adrResp,
        telephoneResponsable: '',
        emailResponsable: ''};*/

    constructor(props: Props) {
        super(props);
        if (this.props.register !== undefined) {
            this.props.register(this);
        }
        this.state = {
            /*nom: '',
            prenom: '',
            date_de_naissance: '',
            adresse: this.adr,
            telephone: '',
            pointure: '',
            taille: '',
            responsable: this.resp,*/
            redirect: false,
            form: SubscriptionsService.getInstance().getDefaultSubscribe1(),
        };
        // this.membership = undefined;
        this.getForm();
    }

    public getData() {
        return this.state.form;
    }

    handleSubmit = () => {
        if (this.state.form.nom === '') {
            alert('Entrer un nom');
            return Promise.reject('');
        } else if (this.state.form.prenom === '') {
            alert('Entrer un prenom');
            return Promise.reject('');
        } else if (this.state.form.date_naissance === '') {
            alert('Entrer une date de naissance');
            return Promise.reject('');
        } else if (this.state.form.adresse.numero === '') {
            alert('Entrer le numéro de la rue');
            return Promise.reject('');
        } else if (this.state.form.adresse.rue === '') {
            alert('Entrer un nom de rue');
            return Promise.reject('');
        } else if (this.state.form.adresse.complement === '') {
            alert('Entrer un complement');
            return Promise.reject('');
        } else if (this.state.form.adresse.ville === '') {
            alert('Entrer une ville');
            return Promise.reject('');
        } else if (this.state.form.adresse.code_postal === '') {
            alert('Entrer un code postal');
            return Promise.reject('');
        } else if (this.state.form.telephone === '') {
            alert('Entrer un numéro de téléphone');
            return Promise.reject('');
        } else {
            return (SubscriptionsService.getInstance().createSubscribePart1(this.state.form, this.props.user_id).then(
                () => {
                    if (this.props.switch !== undefined) {
                        this.props.switch(2);
                    }
                }
            ));
        }
    }

    handleReset = () => {
        this.setState({ form: SubscriptionsService.getInstance().getDefaultSubscribe1() });
        /*this.state.form.nom = '';
        this.setState({ nom: '' });
        this.state.form.prenom = '';
        this.setState({ prenom: '' });
        this.state.form.date_naissance = '';
        this.setState({ date_naissance: '' });
        this.state.form.adresse.complement = '';
        this.setState({ adresse: { complement: '' } });
        this.state.form.adresse.numero = '';
        this.setState({ adresse: { numero: '' } });
        this.state.form.adresse.rue = '';
        this.setState({ adresse: { rue: '' } });
        this.state.form.adresse.code_postal = '';
        this.setState({ adresse: { code_postal: '' } });
        this.state.form.adresse.ville = '';
        this.setState({ adresse: { ville: '' } });
        this.state.form.telephone = '';
        this.setState({ telephone: '' });
        this.state.form.taille = '';
        this.setState({ taille: '' });
        this.state.form.pointure = '';
        this.setState({ pointure: '' });
        if (this.state.form.responsable !== null) {
            this.state.form.responsable.nom = '';
            this.setState({ responsable: { nom: '' } });
            this.state.form.responsable.prenom = '';
            this.setState({ responsable: { prenom: '' } });
            this.state.form.responsable.lien = '';
            this.setState({ responsable: { lien: '' } });
            this.state.form.responsable.date_naissance = '';
            this.setState({ responsable: { date_naissance: '' } });
            this.state.form.responsable.email = '';
            this.setState({ responsable: { email: '' } });
            this.state.form.responsable.telephone = '';
            this.setState({ responsable: { telephone: '' } });
            this.state.form.responsable.adresse.numero = '';
            this.setState({ responsable: { adresse: { numero: '' } } });
            this.state.form.responsable.adresse.rue = '';
            this.setState({ responsable: { adresse: { rue: '' } } });
            this.state.form.responsable.adresse.complement = '';
            this.setState({ responsable: { adresse: { complement: '' } } });
            this.state.form.responsable.adresse.code_postal = '';
            this.setState({ responsable: { adresse: { code_postal: '' } } });
            this.state.form.responsable.adresse.ville = '';
            this.setState({ responsable: { adresse: { ville: '' } } });
        }*/

    }

    render() {
        const hStyle = {
            color: '#ED008C',
            paddingTop: '30px',
            paddingBottom: '50px',
            fontSize: '40px'
        };
        if (this.state.redirect) {
            return <Redirect to={'/membership2'} />;
        }
        return (
            <div>
                <h2 className="text-center" style={hStyle} hidden={this.props.hidden} >
                    Bulletin d'adhésion
                </h2>
                <h3 className="text-center" style={{ float: 'left' }} hidden={this.props.hidden} >
                    Informations générales
                </h3>
                <br />
                <hr hidden={this.props.hidden} />
                <div className="form-group" style={{ marginTop: '1cm' }}>
                    <label
                        htmlFor="Nom"
                        style={{ fontSize: '20px' }}
                        className="offset-1 col-sm-2 text-right col-form-input"
                    >
                        *Nom
                    </label>
                    <input
                        className="form-control-lg col-sm-6"
                        placeholder="Entrer votre nom"
                        type="text"
                        value={this.state.form.nom}
                        disabled={this.props.disabled}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newForm = this.state.form;
                                newForm.nom = e.target.value;
                                this.setState({ form: newForm });
                            }
                        }
                    />
                </div>

                <div className="form-group">
                    <label
                        htmlFor="Prenom"
                        style={{ fontSize: '20px' }}
                        className="offset-1 col-sm-2 text-right col-form-input"
                    >
                        *Prénom
                    </label>
                    <input
                        className="form-control-lg col-sm-6"
                        placeholder="Entrer votre prénom"
                        type="text"
                        value={this.state.form.prenom}
                        disabled={this.props.disabled}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newForm = this.state.form;
                                newForm.prenom = e.target.value;
                                this.setState({ form: newForm });
                            }
                        }
                    />
                </div>

                <div className="form-group">
                    <label
                        htmlFor="Prenom"
                        style={{ fontSize: '20px' }}
                        className="col-sm-3 text-right col-form-input"
                    >
                        *Date de naissance
                    </label>
                    <input
                        className="form-control-lg col-sm-6"
                        placeholder="Date"
                        type="date"
                        value={this.state.form.date_naissance}
                        disabled={this.props.disabled}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newForm = this.state.form;
                                newForm.date_naissance = e.target.value;
                                this.setState({ form: newForm });
                            }
                        }
                    />
                </div>

                <div className="row">
                    <label
                        className=" offset-1 col-sm-2 text-right col-form-input"
                        style={{ fontSize: '20px', marginTop: '14px' }}
                    >
                        *Adresse
                    </label>
                    <div className="form-control-lg col-sm-6">
                        <AdresseForm
                            adresse={this.state.form.adresse}
                            disabled={this.props.disabled}
                            setAdresse={
                                (adresse: ReqType.Adresse) => {
                                    var newForm = this.state.form;
                                    newForm.adresse = adresse;
                                    this.setState({ form: newForm });
                                }
                            }
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label
                        htmlFor="telephone"
                        className="offset-1 col-sm-2 text-right col-form-input"
                        style={{ fontSize: '20px' }}
                    >
                        *Telephone
                    </label>
                    <input
                        className="form-control-lg col-sm-6"
                        placeholder="00 00 00 00 00"
                        type="number"
                        value={this.state.form.telephone}
                        disabled={this.props.disabled}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newForm = this.state.form;
                                newForm.telephone = e.target.value;
                                this.setState({ form: newForm });
                            }
                        }
                    />
                </div>
                <div className="form-group">
                    <label
                        htmlFor="Prenom"
                        style={{ fontSize: '20px' }}
                        className="offset-1 col-sm-2 text-right col-form-input"
                    >
                        Taille (en cm)
                    </label>
                    <input
                        className="form-control-lg col-sm-6"
                        placeholder="Entrer votre taille (en cm)"
                        type="number"
                        value={this.state.form.taille}
                        disabled={this.props.disabled}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newForm = this.state.form;
                                newForm.taille = e.target.value;
                                this.setState({ form: newForm });
                            }
                        }
                    />
                </div>

                <div className="form-group">
                    <label
                        htmlFor="Prenom"
                        style={{ fontSize: '20px' }}
                        className="offset-1 col-sm-2 text-right col-form-input"
                    >
                        Pointure
                    </label>
                    <input
                        className="form-control-lg col-sm-6"
                        placeholder="Entrer votre pointure"
                        type="text"
                        value={this.state.form.pointure.toString()}
                        disabled={this.props.disabled}
                        onChange={
                            (e: React.ChangeEvent<HTMLInputElement>) => {
                                var newForm = this.state.form;
                                newForm.pointure = e.target.value;
                                this.setState({ form: newForm });
                            }
                        }
                    />
                </div>
                <input
                    type="checkbox"
                    style={{ marginBottom: '1cm' }}
                    checked={this.state.form.responsable !== null}
                    disabled={this.props.disabled}
                    onChange={
                        (e: React.ChangeEvent<HTMLInputElement>) => {
                            var newForm = this.state.form;
                            if (e.target.checked) {
                                newForm.responsable = ResponsableService.getInstance().getDefaultResponsable();
                                this.setState({ form: newForm });
                            } else {
                                newForm.responsable = null;
                                this.setState({ form: newForm });
                            }
                        }
                    }
                />
                <label className="form-check-label" style={{ fontSize: '20px' }}>
                    Adhérent mineur
                </label>
                {this.getResponsableForm()}

                <div
                    className="row"
                    hidden={this.props.hidden}
                    style={{ float: 'right', marginRight: '1cm' }}
                >
                    <button
                        onClick={this.handleReset}
                        className="btn btn-outline-danger"
                        style={{
                            marginBottom: '1cm',
                            height: '1.5cm',
                            marginTop: '1cm',
                            width: '4cm'
                        }}
                    >
                        <strong>Rénitialiser</strong>
                    </button>
                    <LoaderButton
                        onClick={this.handleSubmit}
                        className="btn"
                        style={{
                            marginLeft: '1cm',
                            marginBottom: '1cm',
                            height: '1.5cm',
                            marginTop: '1cm',
                            width: '4cm'
                        }}
                    >
                        <strong>Suivant</strong>
                    </LoaderButton>
                </div>
            </div>
        );
    }

    private getForm() {
        SubscriptionsService.getInstance().getSubscribePart1(this.props.user_id).then(
            (form: ReqType.SubscriptionPart1) => {
                this.setState({ form: form });
                return;
            }
        );
    }

    private getResponsableForm() {
        if (this.state.form.responsable === null) {
            return undefined;
        } else {
            return (
                <div>
                    <h2 style={{ float: 'left' }} className="text-center ">Pour Adherent mineur:</h2>
                    <br />
                    <hr />
                    <div className="form-group" style={{ marginTop: '1cm' }}>
                        <label
                            htmlFor="Nom du responsable"
                            style={{ fontSize: '20px' }}
                            className=" col-sm-3 text-right col-form-input"
                        >
                            *Nom du responsable
                        </label>
                        <input
                            className="form-control-lg col-sm-6"
                            placeholder="Entrer votre nom"
                            type="text"
                            value={this.state.form.responsable.nom}
                            disabled={this.props.disabled}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    var newForm = this.state.form;
                                    newForm.responsable!.nom = e.target.value;
                                    this.setState({ form: newForm });
                                }
                            }
                        />
                    </div>

                    <div className="form-group">
                        <label
                            htmlFor="Nom du responsable:"
                            style={{ fontSize: '20px' }}
                            className="col-sm-3 text-right col-form-input"
                        >
                            *Prénom du responsable
                        </label>
                        <input
                            className="form-control-lg col-sm-6"
                            placeholder="Entrer votre prénom"
                            type="text"
                            value={this.state.form.responsable.prenom}
                            disabled={this.props.disabled}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    var newForm = this.state.form;
                                    newForm.responsable!.prenom = e.target.value;
                                    this.setState({ form: newForm });
                                }
                            }
                        />
                    </div>

                    <div className="form-group">
                        <label
                            htmlFor="Lien de parenté"
                            className="col-sm-3 text-right col-form-input"
                            style={{ fontSize: '20px' }}
                        >
                            *Lien de parenté
                        </label>
                        <input
                            className="form-control-lg col-sm-6"
                            placeholder="Parent, tuteur..."
                            type="text"
                            value={this.state.form.responsable.lien}
                            disabled={this.props.disabled}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    var newForm = this.state.form;
                                    newForm.responsable!.lien = e.target.value;
                                    this.setState({ form: newForm });
                                }
                            }
                        />
                    </div>

                    <div className="form-group">
                        <label
                            htmlFor="Prenom"
                            className="col-sm-3 text-right col-form-input"
                            style={{ fontSize: '20px' }}
                        >*Date de naissance
                        </label>
                        <input
                            className="form-control-lg col-sm-6"
                            placeholder="Date"
                            type="date"
                            value={this.state.form.responsable!.date_naissance}
                            disabled={this.props.disabled}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    var newForm = this.state.form;
                                    newForm.responsable!.date_naissance = e.target.value;
                                    this.setState({ form: newForm });
                                }
                            }
                        />
                    </div>

                    <div className="form-group">
                        <label
                            htmlFor="Nom du responsable:"
                            className="col-sm-3 text-right col-form-input"
                            style={{ fontSize: '20px' }}
                        >
                            *Email du responsable
                        </label>
                        <input
                            className="form-control-lg col-sm-6"
                            placeholder="Entrer votre email"
                            type="text"
                            value={this.state.form.responsable.email}
                            disabled={this.props.disabled}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    var newForm = this.state.form;
                                    newForm.responsable!.email = e.target.value;
                                    this.setState({ form: newForm });
                                }
                            }
                        />
                    </div>

                    <div className="row">
                        <label
                            className=" col-sm-3 text-right col-form-input"
                            style={{ fontSize: '20px', marginTop: '14px' }}
                        >
                            *Adresse
                        </label>
                        <div className="form-control-lg col-sm-6">
                            <AdresseForm
                                adresse={this.state.form.responsable.adresse}
                                disabled={this.props.disabled}
                                setAdresse={
                                    (adresse: ReqType.Adresse) => {
                                        var newForm = this.state.form;
                                        newForm.responsable!.adresse = adresse;
                                        this.setState({ form: newForm });
                                    }
                                }
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label
                            htmlFor="telephone"
                            className=" col-sm-3 text-right col-form-input"
                            style={{ fontSize: '20px' }}
                        >
                            *Telephone
                        </label>
                        <input
                            className="form-control-lg col-sm-6"
                            placeholder="00 00 00 00 00"
                            type="number"
                            value={this.state.form.responsable.telephone}
                            disabled={this.props.disabled}
                            onChange={
                                (e: React.ChangeEvent<HTMLInputElement>) => {
                                    var newForm = this.state.form;
                                    newForm.responsable!.telephone = e.target.value;
                                    this.setState({ form: newForm });
                                }
                            }
                        />
                    </div>
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/MembershipPage/internalComponents/Adhere1.tsx